import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExit = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M16 4L4 16M4 4L16 16",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
};
export default SvgExit;
